import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

// Numéro de téléphone cliquable (lance l'appel via tel:) sur la version
// mobile uniquement — sur desktop le numéro reste du texte simple.
// stopPropagation : un numéro affiché dans une carte cliquable doit lancer
// l'appel, pas ouvrir la carte.
// linkClassName : couleur du lien (bleu par défaut) — passer p.ex.
// text-blue-300 sur fond sombre.
export default function PhoneLink({ phone, className = '', linkClassName = 'text-blue-600', children }) {
  const isMobile = useIsMobile();
  if (!phone) return null;
  if (!isMobile) return <span className={className}>{children ?? phone}</span>;
  return (
    <a
      href={`tel:${String(phone).replace(/[^+\d]/g, '')}`}
      onClick={(e) => e.stopPropagation()}
      className={`${linkClassName} ${className}`}
    >
      {children ?? phone}
    </a>
  );
}
